export default __webpack_public_path__ + "static/media/chillLogo.c261c481.svg";